const delhiNCR = [
  "RJ696",
  "UP666",
  "SE004",
  "DW087",
  "JP001",
  "JP002",
  "DL699",
  "DL487",
  "DL477",
  "DL482",
  "DL738",
  "SE606",
  "SE003",
  "DL695",
  "FB019",
  "HR704",
  "GN009",
  "UP727",
  "HR686",
  "HR685",
  "ND008",
  "ND086",
  "DL483",
  "PL037",
  "DL583",
  "UP789",
];

const central = [
  "AG034",
  "UP646",
  "AG032",
  "AD074",
  "UP479",
  "UP694",
  "DH011",
  "DH010",
  "UP497",
  "GP073",
  "HD411",
  "UP644",
  "JH445",
  "KR084",
  "KR036",
  "UP739",
  "UP486",
  "UP484",
  "UP489",
  "UP481",
  "UP463",
  "MR031",
  "UP735",
  "UP630",
  "UP632",
  "UP723",
  "UT621",
  "SP028",
  "UP617",
];

const east = [
  "OR662",
  "OR663",
  "BR671",
  "OR473",
  "OR474",
  "CG692",
  "OR475",
  "BR698",
  "JH674",
  "BR672",
  "AS677",
  "AS678",
  "AS679",
  "BR673",
  "CT564",
  "JH675",
  "OR740",
  "AS680",
];

const rajasthan = [
  "AJ427",
  "RJ490",
  "RJ610",
  "RJ681",
  "RJ467",
  "JR049",
  "JR021",
  "RJ620",
  "RJ614",
  "JP070",
  "RJ716",
  "JD075",
  "KO069",
  "RJ608",
  "RJ462",
  "RJ466",
];

const north = [
  "AB443",
  "AR027",
  "HR624",
  "BH024",
  "BH430",
  "CH012",
  "HP491",
  "HR026",
  "PB472",
  "JD029",
  "PB471",
  "JK705",
  "JK687",
  "JK688",
  "HR469",
  "KA429",
  "KA436",
  "KR033",
  "LD022",
  "NN035",
  "PA059",
  "PP025",
  "PB611",
  "PA060",
  "RK020",
  "SA438",
  "HR495",
  "JK689",
  "HR432",
  "JK785",
];

const west = [
  "AM038",
  "AM047",
  "AM054",
  "GJ623",
  "AM081",
  "GJ648",
  "GJ468",
  "GJ701",
  "BH067",
  "MP613",
  "GJ422",
  "GJ736",
  "GW076",
  "MP602",
  "ID050",
  "ID078",
  "MP707",
  "JP072",
  "GJ609",
  "GJ649",
  "GJ600",
  "GJ700",
  "GJ664",
  "MP639",
  "MP697",
  "MP618",
  "DN690",
  "SU079",
  "SU056",
  "SU457",
  "GJ682",
  "UJ426",
  "VD039",
  "VD080",
  "GJ458",
  "MP709",
  "MH494",
  "AK409",
  "AM061",
  "MH634",
  "MH710",
  "GO066",
  "MH493",
  "MH607",
  "MH478",
  "GO421",
  "MB419",
  "MB016",
  "MB018",
  "MB017",
  "MB415",
  "BO063",
  "MH683",
  "MB015",
  "MH714",
  "MB068",
  "MH657",
  "MH647",
  "MB417",
  "MH651",
  "MH631",
  "MH476",
  "MH712",
  "MH784",
  "MH645",
  "MH711",
  "MH643",
  "MH616",
  "PN085",
  "PN014",
  "MH642",
  "MH633",
  "MH480",
  "MH787",
];

const south = [
  "KA654",
  "BG442",
  "BH083",
  "BI040",
  "BJ042",
  "BR041",
  "BG447",
  "BG446",
  "BH410",
  "HB065",
  "WF064",
  "KA626",
  "KL043",
  "KL046",
  "KL048",
  "CL051",
  "TR403",
  "KL676",
  "PD459",
  "CN023",
  "CN030",
  "KA637",
  "CO052",
  "KA667",
  "AP492",
  "KA619",
  "AN062",
  "HU401",
  "HY044",
  "HY082",
  "TG660",
  "TG635",
  "HY095",
  "KP053",
  "HY096",
  "HY045",
  "TG720",
  "AP669",
  "AP691",
  "CN097",
  "KN094",
  "CN098",
  "TR099",
  "KL089",
  "MD400",
  "CO425",
  "MG444",
  "MY402",
  "MY454",
  "TN434",
  "NE431",
  "VL439",
  "TG496",
  "MD465",
  "KA636",
  "TN622",
  "TN627",
  "TN629",
  "TR090",
  "TN641",
  "TN656",
  "TN668",
  "TN719",
  "KA628",
  "TN737",
  "VJ091",
  "VZ057",
  "VZ088",
  "AP652",
  "WR093",
  "TN790",
];

export const businessAreaAccess = [
  ...delhiNCR,
  ...central,
  ...east,
  ...rajasthan,
  ...north,
  ...west,
  ...south,
];
